export function fileUpload() {
    const $inputFile = $("input[type='file']");
    $inputFile.each(function () {
        let $this = $(this);
        $this.wrap("<div class='custom-file-upload'></div>")
        $(".custom-file-upload").append("<button class='button'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\">\n" +
            "  <path d=\"M8.5 9.90909V1M8.5 1L5.31818 4.18182M8.5 1L11.6818 4.18182M15.5 9.90909V15H1.5V9.90909\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "</svg><span>Upload file</span></button>");
    });
    $inputFile.on("change", function () {
        let $this = $(this);
        let fileName = $this.val();
        $this.parent().find(".button span").text(fileName.split(/(\\|\/)/g).pop());
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/fileUpload.js